import FeaturesManager from 'utils/features/FeaturesManager';

// Register the feature flag for Risk Pool Performance Reporting demo data
FeaturesManager.registerFeature({
  id: 'risk_pool_performance_reporting_demo',
  name: 'Risk Pool Performance Reporting Demo',
  description: 'Enable demo data for Risk Pool Performance Reporting (mocked calculations). When disabled, fetches real data from API.',
  enabled: false,
  maxEnv: 'prod',
});

/**
 * Hook to check if Risk Pool Performance Reporting demo data mode is enabled.
 * When enabled, all Risk Pool Performance Reporting data sources will return mock/demo data instead of API data.
 * This is used for sales demos and testing purposes.
 *
 * @returns {boolean} True if demo data should be used, false if real API data should be used
 */
export const useRiskPoolPerformanceReportingDemo = (): boolean => {
  return FeaturesManager.getInstance().isFeatureEnabled('risk_pool_performance_reporting_demo');
};

